/**
 * AccountCard - Displays user account information
 */
export default function AccountCard({ user }) {
  return (
    <div className="card">
      <div className="card-header">
        <h3 className="font-semibold" style={{ color: 'var(--color-text-primary)' }}>Account</h3>
      </div>
      <div className="card-body">
        <div className="flex items-center gap-4">
          <div 
            className="w-16 h-16 rounded-full flex items-center justify-center"
            style={{ backgroundColor: 'var(--color-brand-primary-soft)' }}
          >
            <span 
              className="text-2xl font-bold"
              style={{ color: 'var(--color-brand-primary)' }}
            >
              {user?.email?.[0]?.toUpperCase()}
            </span>
          </div>
          <div>
            <div className="font-medium" style={{ color: 'var(--color-text-primary)' }}>
              {user?.email}
            </div>
            <div className="text-sm" style={{ color: 'var(--color-text-muted)' }}>
              Authenticated via Cloudflare Access
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
